import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function PendingApprovalPage() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-3 text-gray-800">Your account is pending approval</h2>
        <p className="mb-6 text-gray-600">An admin will approve your account soon.</p>
        <button
          onClick={handleLogout}
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 rounded-lg transition"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
